import type { CSSProperties } from 'react';

export const resolveVirtualRowTopOffset = (
  styleTop: CSSProperties['top'],
  padding: number
): number => {
  let parsedTop = 0;

  if (typeof styleTop === 'number') {
    parsedTop = styleTop;
  } else if (typeof styleTop === 'string') {
    parsedTop = Number.parseFloat(styleTop);
  }

  return Number.isNaN(parsedTop) ? padding : parsedTop + padding;
};
